import fromEntries from 'fromentries';

// Removes all top-level values of an object that are null, undefined, or empty string.
export function shallowRemoveBlankValues(obj: object): object {
  return fromEntries(
    Object.entries(obj).filter(([_, v]) => v !== null && v !== undefined && v !== ''),
  );
}
